export const manifestLocales = {
  interactiveQuiz: {
    previewImageAlt: {
      en: 'Interactive quiz',
      he: 'Interactive quiz [HE]'
    },
    initialHeadlineText: {
      en: 'Headline / Question',
      he: 'כותרת/שאלה'
    },
    defaultAnswer: {
      en: 'Answer',
      he: 'תשובה'
    }
  }
};
